import React from "react"
import { List } from "./styles"

export const VehicleLargeCardList = ({ children }) => <List>{children}</List>
